import { c as _c } from "react/compiler-runtime";
import { CLASSIFICATIONS } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatTimestampToMonthYear } from "@/helpers/Helpers";
import UserCICTypeIconWrapper from "@/components/user/utils/user-cic-type/UserCICTypeIconWrapper";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { ArtistActivityBadge } from "@/components/waves/drops/ArtistActivityBadge";
import type { ArtistPreviewTab } from "@/hooks/useArtistPreviewModal";
import UserPageClassificationWrapper from "./classification/UserPageClassificationWrapper";
import UserPageHeaderNameWrapper from "./UserPageHeaderNameWrapper";
export default function UserPageHeaderName(t0) {
  const $ = _c(24);
  const {
    profile,
    canEdit,
    mainAddress,
    level,
    profileEnabledAt,
    variant: t1,
    submissionCount: t2,
    winnerCount: t3,
    onBadgeClick
  } = t0;
  const variant = t1 === undefined ? "full" : t1;
  const submissionCount = t2 === undefined ? 0 : t2;
  const winnerCount = t3 === undefined ? 0 : t3;
  let t4;
  if ($[0] !== mainAddress || $[1] !== profile.display || $[2] !== profile.handle) {
    const getDisplayName = () => {
      if (profile?.handle) {
        return profile.handle;
      }
      if (profile.display) {
        return profile.display;
      }
      if (mainAddress.endsWith(".eth")) {
        return mainAddress;
      }
      return mainAddress;
    };
    t4 = getDisplayName();
    $[0] = mainAddress;
    $[1] = profile.display;
    $[2] = profile.handle;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const displayName = t4;
  let t5;
  if ($[4] !== profileEnabledAt) {
    t5 = profileEnabledAt ? formatTimestampToMonthYear(new Date(profileEnabledAt).getTime()) : null;
    $[4] = profileEnabledAt;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const profileEnabledLabel = t5;
  const showTitle = variant !== "meta";
  const showMeta = variant !== "title";
  const t6 = showTitle && showMeta ? "tw-space-y-2" : "";
  let t7;
  if ($[6] !== canEdit || $[7] !== displayName || $[8] !== level || $[9] !== onBadgeClick || $[10] !== profile || $[11] !== showTitle || $[12] !== submissionCount || $[13] !== winnerCount) {
    t7 = showTitle && <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2"><UserPageHeaderNameWrapper profile={profile} canEdit={canEdit}><p className="tw-mb-0 tw-break-all tw-text-left tw-text-xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-white md:tw-text-2xl">{displayName}</p></UserPageHeaderNameWrapper>{profile?.handle && <div className="xl:tw-mt-1 tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center"><UserCICTypeIconWrapper profile={profile} /></div>}<UserCICAndLevel level={level} size={UserCICAndLevelSize.SMALL} />{onBadgeClick && (submissionCount > 0 || winnerCount > 0) && <ArtistActivityBadge submissionCount={submissionCount} winCount={winnerCount} onBadgeClick={onBadgeClick} tooltipId="profile-artist-activity-badge" />}</div>;
    $[6] = canEdit;
    $[7] = displayName;
    $[8] = level;
    $[9] = onBadgeClick;
    $[10] = profile;
    $[11] = showTitle;
    $[12] = submissionCount;
    $[13] = winnerCount;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== canEdit || $[16] !== profile || $[17] !== profileEnabledLabel || $[18] !== showMeta) {
    t8 = showMeta && <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1">{profile?.classification && <UserPageClassificationWrapper profile={profile} canEdit={canEdit}><div className="tw-block tw-text-sm tw-font-medium tw-leading-4 tw-text-zinc-400 tw-transition tw-duration-300 tw-ease-out hover:tw-text-white">{CLASSIFICATIONS[profile.classification].title}</div></UserPageClassificationWrapper>}{profileEnabledLabel && <span className="tw-text-zinc-600 sm:tw-text-zinc-700">•</span>}{profileEnabledLabel && <p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-zinc-500" suppressHydrationWarning={true}>Profile enabled: {profileEnabledLabel}</p>}</div>;
    $[15] = canEdit;
    $[16] = profile;
    $[17] = profileEnabledLabel;
    $[18] = showMeta;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <div className={t6}>{t7}{t8}</div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}